import moment from "moment";
import { BaseTestId, Test } from "../graphql/baseTypes";
import { Address, CreateTestInput } from "../graphql/types";

export const generateIdFromTest = (item: Test | BaseTestId) =>
  `${item.testId}#${item.date}`;
export const generateLongIdFromTest = (item: Test | CreateTestInput) =>
  `${item.locationId}#${item.testId}#${item.date}`;

export const parseDate: (date: string | Date, isEnd?: boolean) => string = (
  date,
  isEnd
) =>
  moment(date)
    .set(
      isEnd
        ? { hour: 23, minutes: 59, seconds: 59 }
        : { hour: 0, minutes: 0, seconds: 0, milliseconds: 0 }
    )
    .toISOString();

export const transformToAddressString = (address?: Address) => {
  if (!address) {
    return undefined;
  }
  return `${
    address.street && address.street !== null ? address.street + " " : ""
  }${address.number && address.number !== null ? address.number + ", " : ""}${
    address.zip && address.zip !== null ? address.zip + " " : ""
  }${address.city && address.city !== null ? address.city : ""}`;
};
